import React from 'react';
import AutosaveActivityCard from './AutosaveActivityCard';
import PendingAutosaveActivityCard from './PendingAutosaveActivityCard';
import UpcomingAutosavePaymentCard from './UpcomingAutosavePaymentCard';
const UpcomingAutosaveActivity = ({ upcomingPaymentOrActivity }) => {
    if ('status' in upcomingPaymentOrActivity) {
        if (upcomingPaymentOrActivity.status === 'PENDING') {
            return <PendingAutosaveActivityCard activity={upcomingPaymentOrActivity}/>;
        }
        return <AutosaveActivityCard withCard activity={upcomingPaymentOrActivity}/>;
    }
    return <UpcomingAutosavePaymentCard upcomingPayment={upcomingPaymentOrActivity}/>;
};
export default UpcomingAutosaveActivity;
